export default "__VITE_ASSET__CJXt9Hvu__"